import React from 'react';
import Box from '@mui/material/Box';
import { NavLink, useLocation } from 'react-router-dom';
import drawerBarStyles from '@/common/components/NavigationBar/DrawerBar.styles';

const Navigation = ({ list, isMobileLayout, onCloseMobileMenu }) => {
  const location = useLocation();

  return (
    <Box sx={drawerBarStyles.navigationList}>
      {list.map(
        ({
          link,
          text,
          onClick,
          isActive,
          external,
          endAdornment,
          highlightOnHover,
          ...props
        }) => {
        const active = isActive
          ? isActive(null, location)
          : !external && location.pathname === link;

        return (
          <Box
            component={external ? 'a' : NavLink}
            key={link}
            sx={[
              drawerBarStyles.navigationListItem,
              highlightOnHover && drawerBarStyles.navigationListItemHoverable,
              endAdornment && drawerBarStyles.navigationListItemAdornmentVisible,
              active && drawerBarStyles.navigationListItemActive,
            ]}
            {...(external ? { href: link } : { to: link })}
            onClick={(event) => {
              onClick?.(event);

              if (isMobileLayout) {
                onCloseMobileMenu();
              }
            }}
            {...props}
          >
            <Box sx={drawerBarStyles.navigationListItemContent}>{text}</Box>
            {endAdornment ? (
              <Box
                className="navigation-list-item-adornment"
                sx={drawerBarStyles.navigationListItemAdornment}
              >
                {endAdornment}
              </Box>
            ) : null}
          </Box>
        );
        }
      )}
    </Box>
  );
};

export default Navigation;
